module.exports = __webpack_public_path__ + "static/media/img-visa.fce1da29.jpg";